import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiMapPin, FiShield, FiClock, FiStar, FiUsers } = FiIcons;

const reasons = [
  { icon: FiAward, title: "Veteran Owned", desc: "Military precision and integrity driven into every detail. We don't cut corners." },
  { icon: FiStar, title: "Pro-Grade Products", desc: "We use only industry-leading chemicals and safe wash methods — no shortcuts, ever." },
  { icon: FiMapPin, title: "Jacksonville Local", desc: "Proudly serving Jacksonville and surrounding areas. We're your neighbors." },
  { icon: FiShield, title: "Fully Insured", desc: "Every service is backed by insurance so your vehicle is always protected." },
  { icon: FiClock, title: "On Time, Every Time", desc: "We respect your schedule. Punctual, professional, and reliable." },
  { icon: FiUsers, title: "Built on Trust", desc: "Repeat customers and referrals are the backbone of our business." },
];

const SIDE_IMG = "https://images.unsplash.com/photo-1614026480209-cd9934144671?auto=format&fit=crop&q=80";

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-slate-950 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <div>
            <span className="text-blue-500 font-bold tracking-widest uppercase text-xs mb-3 block">Why Choose Us</span>
            <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6">
              Obsessed with<br />the Details.
            </h2>
            <p className="text-slate-300 text-lg mb-10 leading-relaxed">
              We don't just wash cars — we restore and protect them. As Jacksonville's premium local detailing service, we prioritize quality over volume. Whether it's a quick Fresh Ride or a full Elite Detail with ceramic coating, expect meticulous care and a flawless finish every time.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {reasons.map((r, i) => (
                <motion.div 
                  key={i}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.07 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-10 h-10 bg-blue-600/10 border border-blue-500/20 rounded-sm flex items-center justify-center flex-shrink-0">
                    <r.icon className="text-blue-500 text-lg" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-sm uppercase tracking-wide mb-1">{r.title}</h4>
                    <p className="text-slate-400 text-xs leading-relaxed">{r.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/5] bg-slate-900 border border-slate-800 overflow-hidden">
              <img 
                src={SIDE_IMG} 
                alt="Premium auto detailing Jacksonville" 
                className="w-full h-full object-cover opacity-80 hover:opacity-100 transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 to-transparent" />
            </div>
            
            <div className="absolute -bottom-6 -left-6 bg-blue-600 p-6 shadow-2xl hidden md:block">
              <div className="text-white font-black text-2xl">100%</div>
              <div className="text-blue-200 text-xs font-bold uppercase tracking-wider">Satisfaction Focus</div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}